import { createAction } from 'redux-actions';

export const SET_SESSION_ID = 'SET_SESSION_ID';

const setSessionId = createAction(SET_SESSION_ID);

export default {
    setSessionId
};



// WEBPACK FOOTER //
// ./containers/app/session-id/session-id-actions.js